import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import './styles.css';

// React Query is provisioned now for later sprints (lobby, matchmaking, saves).
const queryClient = new QueryClient();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

// NOTE: StrictMode is intentionally omitted — its double-invoked effects would
// initialise/destroy the WebGL context twice. It will be re-enabled around the
// pure-React UI subtree once the canvas is isolated behind a stable boundary.
void StrictMode;

createRoot(rootEl).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
